import React from 'react';
import { ChiOption } from '../core/types';
import CardComponent from './CardComponent';
import '../styles/Modals.css';

interface ActionModalProps {
  chiOptions: ChiOption[];
  onSelectOption: (option: ChiOption) => void;
  onCancel: () => void;
}

const ActionModal: React.FC<ActionModalProps> = ({
  chiOptions,
  onSelectOption,
  onCancel
}) => {
  return (
    <div className="modal-overlay">
      <div className="modal-content action-select-modal">
        <div className="modal-header">
          <h3>🍚 请选择吃牌方案</h3>
          <button className="modal-close-btn" onClick={onCancel}>
            ✕
          </button>
        </div>

        <div className="chi-options-list">
          {chiOptions.map((opt, idx) => (
            <div
              key={opt.id || idx}
              className="chi-option-card"
              onClick={() => onSelectOption(opt)}
            >
              <div className="chi-option-meta">
                <span className="chi-option-name">{opt.name}</span>
                {opt.huxi > 0 && <span className="chi-option-huxi">+{opt.huxi}胡</span>}
              </div>
              <div className="chi-option-cards">
                {opt.meldCards.map((card, cIdx) => (
                  <div key={card.id || cIdx} className="chi-card-wrapper">
                    <CardComponent
                      card={card}
                      isSmall={true}
                      highlight={card.id === opt.targetCard.id}
                      badge={card.id === opt.targetCard.id ? '进' : undefined}
                    />
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>

        <div className="modal-footer">
          <button className="btn-secondary" onClick={onCancel}>
            放弃吃牌
          </button>
        </div>
      </div>
    </div>
  );
};

export default ActionModal;